import { render, staticRenderFns } from "./ChairIcon.vue?vue&type=template&id=3c4ea59b&scoped=true"
import script from "./ChairIcon.vue?vue&type=script&lang=js"
export * from "./ChairIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ea59b",
  null
  
)

export default component.exports